// InfoPage.jsx
// Public landing page for new patients.
// This is what the QR code points to — scanned from a flyer, poster, or reception desk.
// URL: /info

const CLINIC = {
  name:    "KSM CareLink Virtual Care",
  tagline: "Quality care from the comfort of home",
  phone:   "(555) 123-4567",
  email:   "care@ksmtechnologies.net",
  website: "https://ksmtechnologies.net",
  address: "123 Medical Plaza, Suite 400\nAustin, TX 78701",
  hours: [
    { day: "Monday – Friday", time: "8:00 AM – 6:00 PM" },
    { day: "Saturday",        time: "9:00 AM – 2:00 PM" },
    { day: "Sunday",          time: "Closed"             },
  ],
  bookingSteps: [
    { icon: "📞", title: "Call or email us",       desc: "Reach our team by phone or email to schedule your virtual appointment." },
    { icon: "📧", title: "Receive your invite",    desc: "We'll send a secure video link to your email before your appointment." },
    { icon: "🖥",  title: "Join from any device",  desc: "Click the link on your phone, tablet, or computer — no app download needed." },
    { icon: "👨‍⚕️", title: "See your doctor",       desc: "Meet face-to-face with your provider from wherever you are." },
  ],
};

export default function InfoPage() {
  return (
    <div className="info-page">

      {/* Hero */}
      <header className="info-hero">
        <div className="info-logo">KSM <span>CareLink</span></div>
        <h1 className="info-hero-title">{CLINIC.tagline}</h1>
        <p className="info-hero-sub">
          See a doctor online — no waiting room, no commute.
        </p>
      </header>

      <main className="info-main">

        {/* How it works */}
        <section className="info-section" aria-labelledby="how-heading">
          <h2 className="info-section-title" id="how-heading">How to book an appointment</h2>
          <div className="info-steps">
            {CLINIC.bookingSteps.map((step, i) => (
              <div className="info-step" key={i}>
                <div className="step-icon" aria-hidden="true">{step.icon}</div>
                <div className="step-body">
                  <h3 className="step-title">{step.title}</h3>
                  <p  className="step-desc">{step.desc}</p>
                </div>
                {i < CLINIC.bookingSteps.length - 1 && (
                  <div className="step-arrow" aria-hidden="true">→</div>
                )}
              </div>
            ))}
          </div>
        </section>

        {/* Contact + Hours */}
        <div className="info-grid">

          <section className="info-card" aria-labelledby="contact-heading">
            <h2 className="info-card-title" id="contact-heading">
              <span aria-hidden="true">📍</span> Contact us
            </h2>
            <ul className="info-contact-list">
              <li>
                <span className="contact-label">Phone</span>
                <a href={`tel:${CLINIC.phone.replace(/\D/g,"")}`} className="contact-value link">
                  {CLINIC.phone}
                </a>
              </li>
              <li>
                <span className="contact-label">Email</span>
                <a href={`mailto:${CLINIC.email}`} className="contact-value link">
                  {CLINIC.email}
                </a>
              </li>
              <li>
                <span className="contact-label">Website</span>
                <a href={CLINIC.website} target="_blank" rel="noreferrer" className="contact-value link">
                  {CLINIC.website}
                </a>
              </li>
              <li>
                <span className="contact-label">Address</span>
                <span className="contact-value" style={{ whiteSpace: "pre-line" }}>
                  {CLINIC.address}
                </span>
              </li>
            </ul>
          </section>

          <section className="info-card" aria-labelledby="hours-heading">
            <h2 className="info-card-title" id="hours-heading">
              <span aria-hidden="true">🕐</span> Hours of operation
            </h2>
            <ul className="info-hours-list">
              {CLINIC.hours.map(({ day, time }) => (
                <li key={day} className="info-hours-row">
                  <span className="hours-day">{day}</span>
                  <span className={`hours-time ${time === "Closed" ? "hours-closed" : ""}`}>
                    {time}
                  </span>
                </li>
              ))}
            </ul>
            <p className="hours-note">
              After-hours urgent visits may be available — call to confirm.
            </p>
          </section>

        </div>

        {/* CTA */}
        <section className="info-cta" aria-labelledby="cta-heading">
          <h2 id="cta-heading" className="info-cta-title">Ready to get started?</h2>
          <p className="info-cta-sub">
            Call us or send an email and we'll get your virtual appointment scheduled right away.
          </p>
          <div className="info-cta-actions">
            <a href={`tel:${CLINIC.phone.replace(/\D/g,"")}`} className="btn btn-primary info-cta-btn">
              📞 Call {CLINIC.phone}
            </a>
            <a href={`mailto:${CLINIC.email}`} className="btn btn-navy info-cta-btn">
              ✉️ Email us
            </a>
          </div>
        </section>

      </main>

      <footer className="info-footer">
        <p>© {new Date().getFullYear()} KSM CareLink · Virtual Care Platform</p>
      </footer>

    </div>
  );
}
